import { getUrlParameter } from './url-parameter';

export const THEME = {
  SLOTOKING_WH: 'Slotoking-White',
  SLOTOKING_OUTDATED: 'Slotoking',
  SLOTOKING_BL: 'Slotoking-Black',
  STORM_RUSH_BL: 'StormRush-Black',
  TRIPPLE_SEVEN_WH: '777-White',
  TRIPPLE_SEVEN_WHITE_OUTDATED: '777',
  TRIPPLE_SEVEN_BL: '777-Black',
  TRIPPLE_SEVEN_BL_VER2: '777-Black_ver2',
  NLC: 'NLC',
  NLC_V2: 'NLC_V2',
  NLC_V3: 'NLC_V3',
  NLC_V4: 'NLC_V4',
  NLC_OUTDATED: 'Nolimitcoin',
  FORTUNE_WHEELZ: 'FW',
  FORTUNE_WHEELZ_OUTDATED: 'FortuneWheelz',
  FORTUNE_WHEELZ_VER2: 'FortuneWheelz_ver2',
  JACKPOTT_RABBIT: 'JR',
  JACKPOTT_RABBIT_OUTDATED: 'JackpottRabbit',
  VEGAS_BL: 'Vegas-Black',
  VEGAS_BL_VER2: 'Vegas-Black_ver2',
  WILDWINZ_BL: 'WW-Black',
  FCITY: 'FCITY',
  SCARLET_BL: 'ScarletSands-Black',
  SCARLET_BL_VER2: 'ScarletSands-Black_ver2',
  FUNRIZE_BL: 'Funrize-Black',
  TAO_FORTUNE_BL: 'TAO-Fortune-Black',
  TAO_FORTUNE_BL_VER2: 'TAO-Fortune-Black_ver2',
  SWEEP_SHARK_BL: 'Sweepshark-Black',
  MR_GOODWIN_BL: 'MrGoodwin-Black',
  PLAYTANA_BL: 'Playtana-Black',
  VEGAS_WAY_BL: 'VegasWay-Black',
  SWEEPICO_BL: 'SWP-Black',
  FIRE_SEVENS_BL: 'FireSevens-Black',
  DEXYPLAY_BL: 'Dexyplay-Black',
  PRIZEVILLE_BL: 'PRV',
  COINS_MANIA_BL: 'CM',
  MY_SWEEPZ_BL: 'MYS',
  JUMANZA: 'JMZ',
  CARDRIZE_BL: 'CARDRIZE-Black',
};

export function appTheme() {
  const theme = getUrlParameter('theme');

  switch (theme) {
    case THEME.MY_SWEEPZ_BL:
      return mySweepzBlackTheme();
    case THEME.PRIZEVILLE_BL:
      return prizevilleBlackTheme();
    case THEME.COINS_MANIA_BL:
      return coinsManiaBlackTheme();
    case THEME.DEXYPLAY_BL:
      return dexyplayBlackTheme();
    case THEME.FIRE_SEVENS_BL:
      return fireSevensBlackTheme();
    case THEME.SWEEPICO_BL:
      return sweepicoBlackTheme();
    case THEME.VEGAS_WAY_BL:
      return vegasWayBlackTheme();
    case THEME.PLAYTANA_BL:
      return playtanaBlackTheme();
    case THEME.MR_GOODWIN_BL:
      return mrGoodwinBlackTheme();
    case THEME.SLOTOKING_WH:
    case THEME.SLOTOKING_OUTDATED:
      return slotoKingTheme();
    case THEME.SLOTOKING_BL:
      return slotoKingBlackTheme();
    case THEME.STORM_RUSH_BL:
      return stormRushBlackTheme();
    case THEME.TRIPPLE_SEVEN_WH:
    case THEME.TRIPPLE_SEVEN_WHITE_OUTDATED:
      return thrippleSevenWhiteTheme();
    case THEME.TRIPPLE_SEVEN_BL:
      return trippleSevenBlackTheme();
    case THEME.TRIPPLE_SEVEN_BL_VER2:
      return trippleSevenBlackVer2Theme();
    case THEME.JACKPOTT_RABBIT:
    case THEME.JACKPOTT_RABBIT_OUTDATED:
      return jackpottRabbitTheme();
    case THEME.NLC:
    case THEME.NLC_OUTDATED:
      return nlcTheme();
    case THEME.NLC_V2:
      return nlcV2Theme();
    case THEME.NLC_V3:
      return nlcV3Theme();
    case THEME.NLC_V4:
      return nlcV4Theme();
    case THEME.FORTUNE_WHEELZ:
    case THEME.FORTUNE_WHEELZ_OUTDATED:
      return fortuneWheelzTheme();
    case THEME.FORTUNE_WHEELZ_VER2:
      return fortuneWheelzVer2Theme();
    case THEME.VEGAS_BL:
      return vegasBlackTheme();
    case THEME.VEGAS_BL_VER2:
      return vegasBlackVer2Theme();
    case THEME.WILDWINZ_BL:
      return wildWinzBlackTheme();
    case THEME.FCITY:
      return fcityTheme();
    case THEME.SCARLET_BL:
      return scarlettBlackTheme();
    case THEME.SCARLET_BL_VER2:
      return scarlettBlackVer2Theme();
    case THEME.FUNRIZE_BL:
      return funrizeBlackTheme();
    case THEME.TAO_FORTUNE_BL:
      return taoFortuneTheme();
    case THEME.TAO_FORTUNE_BL_VER2:
      return taoFortuneVer2Theme();
    case THEME.SWEEP_SHARK_BL:
      return sweepSharkBlackTheme();
    case THEME.JUMANZA:
      return jumanzaTheme();
    case THEME.CARDRIZE_BL:
      return cardrizeBlackTheme();
    default:
      return slotoKingTheme();
  }
}

export const appThemeFontFamily = () => {
  const theme = getUrlParameter('theme');

  switch (theme) {
    case THEME.SLOTOKING_WH:
    case THEME.SLOTOKING_OUTDATED:
      return 'Roboto';
    case THEME.SLOTOKING_BL:
    case THEME.TRIPPLE_SEVEN_BL:
      return 'OpenSans';
    case THEME.TRIPPLE_SEVEN_WH:
    case THEME.TRIPPLE_SEVEN_WHITE_OUTDATED:
    case THEME.TRIPPLE_SEVEN_BL_VER2:
    case THEME.FIRE_SEVENS_BL:
      return 'Geologica';
    case THEME.NLC:
    case THEME.NLC_OUTDATED:
    case THEME.NLC_V2:
      return 'ReadexPro';
    case THEME.FORTUNE_WHEELZ:
    case THEME.FORTUNE_WHEELZ_OUTDATED:
    case THEME.TAO_FORTUNE_BL:
    case THEME.TAO_FORTUNE_BL_VER2:
      return 'Rubik';
    case THEME.FORTUNE_WHEELZ_VER2:
    case THEME.MR_GOODWIN_BL:
      return 'Poppins';
    case THEME.JACKPOTT_RABBIT:
    case THEME.JACKPOTT_RABBIT_OUTDATED:
    case THEME.NLC_V3:
    case THEME.NLC_V4:
    case THEME.JUMANZA:
      return 'WorkSans';
    case THEME.VEGAS_BL:
    case THEME.VEGAS_BL_VER2:
    case THEME.VEGAS_WAY_BL:
      return 'Raleway';
    case THEME.WILDWINZ_BL:
      return 'Jost';
    case THEME.FCITY:
      return 'Montserrat';
    case THEME.SCARLET_BL:
    case THEME.SCARLET_BL_VER2:
    case THEME.PRIZEVILLE_BL:
      return 'DMSans';
    case THEME.FUNRIZE_BL:
      return 'Outfit';
    case THEME.SWEEP_SHARK_BL:
    case THEME.STORM_RUSH_BL:
    case THEME.DEXYPLAY_BL:
    case THEME.COINS_MANIA_BL:
    case THEME.CARDRIZE_BL:
      return 'Kanit';
    case THEME.PLAYTANA_BL:
      return 'Urbanist';
    case THEME.SWEEPICO_BL:
      return 'Baloo2';
    case THEME.MY_SWEEPZ_BL:
      return 'Figtree';
    default:
      return 'Roboto';
  }
};

export const appThemeName = (shop) =>
  getUrlParameter('theme') || shop?.theme || '';

function cardrizeBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#000',
      cardSecondaryColor: '#bcbcbc',
      cardBg: '#1f1f1f',
      inputColor: '#FFF',
      inputLabel: '#b2b2b2',
      inputLabelFocused: '#b2b2b2',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#bcbcbc',
      inputBorder: '#484848',
      inputBorderFocused: '#5a5a5a',
      inputBorderError: '#FF0101',
      inputBackground: '#1f1f1f',
      inputBackgroundError: '#1f1f1f',
      inputBackgroundHover: '#1f1f1f',
      inputBackgroundFocus: '#1f1f1f',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#ff0000',
      submitHoverBg: '#ff0000',
      submitActiveBg: '#ff0000',
      submitDisabledBg: '#3D3D3D',
      submitDisabledColor: '#c5c5c5',
      submitBorder: '#ff97a0',
      submitBorderDisabled: '#ff97a0',
      submitBoxShadow: '#FFFFFFB3',
      publicOffer: '#b2b2b2',
      linkColor: '#e6e6e6',
      linkColorHover: '#CCC',
      linkColorActive: '#FFF',
      loaderColor: '#ffd98f',
      error: '#FF0101',
      errorColorText: '#FF0101',
      errorPlaceholderColorText: '#FF0101',
    },
  };
}

function jumanzaTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#160029',
      cardSecondaryColor: '#c0aecb',
      cardBg: '#220034',
      inputColor: '#F9F5FF',
      inputLabel: '#d0cad4',
      inputLabelFocused: '#d0cad4',
      inputLabelAsteriks: '#d0cad4',
      inputPlaceholderColor: '#FFF',
      inputBorder: '#553c62',
      inputBorderFocused: '#684978',
      inputBorderError: '#ff0000',
      inputBackground: '#2d0a3e',
      inputBackgroundError: '#2d0a3e',
      inputBackgroundHover: '#2d0a3e',
      inputBackgroundFocus: '#2d0a3e',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#100128',
      submitBg: '#00ff00',
      submitHoverBg: '#00ff00',
      submitActiveBg: '#00ff00',
      submitDisabledBg: '#452a54',
      submitDisabledColor: '#a196a9',
      // submitBorder: '#',
      // submitBorderDisabled: '#',
      // submitBoxShadow: '#',
      publicOffer: '#c0aecb',
      linkColor: '#e6e6e6',
      linkColorHover: '#CCC',
      linkColorActive: '#FFF',
      loaderColor: '#ffd98f',
      error: '#FF0101',
      errorColorText: '#FF0101',
      errorPlaceholderColorText: '#FF0101',
    },
  };
}

function mySweepzBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#0f0f10',
      cardSecondaryColor: '#d3d3d4',
      cardBg: '#242528',
      inputColor: '#FBFBFC',
      inputLabel: '#FFF',
      inputLabelFocused: '#FFF',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#BDBEC4',
      inputBorder: '#55565E',
      inputBorderFocused: '#747681',
      inputBorderError: '#FF5533',
      inputBackground: '#0f0f10',
      inputBackgroundError: '#0f0f10',
      inputBackgroundHover: '#0f0f10',
      inputBackgroundFocus: '#0f0f10',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#000',
      submitBg: '#fcfbc6',
      submitHoverBg: '#fff2bb',
      submitActiveBg: '#fcfbc9',
      submitDisabledBg: '#86856b',
      submitDisabledColor: '#000',
      // submitBorder: '#',
      // submitBorderDisabled: '#',
      // submitBoxShadow: '#',
      publicOffer: '#FFF',
      linkColor: '#d3d3d3',
      linkColorHover: '#a9a9a9',
      linkColorActive: '#d7d7d7',
      loaderColor: '#FFF5C9',
      error: '#FF5533',
      errorColorText: '#FFF5C9',
      errorPlaceholderColorText: '#FBFBFC',
    },
  };
}

function prizevilleBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F4F5F5',
      background: '#041411',
      cardSecondaryColor: '#C0C4C3',
      cardBg: '#0e1d1b',
      inputColor: '#DFE1E1',
      // inputLabel: '#',
      // inputLabelFocused: '#',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#B0B5B4',
      inputBorder: '#3d4a47', // when input have state #747d7b
      inputBorderFocused: '#8f9796',
      inputBorderError: '#A60306',
      inputBackground: '#182724',
      inputBackgroundError: '#182724',
      inputBackgroundHover: '#182724',
      inputBackgroundFocus: '#182724',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#F4F5F5',
      submitBg: '#C70014',
      submitHoverBg: '#b30012',
      submitActiveBg: '#e60017',
      submitDisabledBg: '#1d1d1d',
      submitDisabledColor: '#8a9391',
      submitBorder: '#C20013',
      submitBorderDisabled: '#1d1d1d',
      // submitBoxShadow: '#',
      publicOffer: '#C0C4C3',
      linkColor: '#3BB098',
      linkColorHover: '#359e89',
      linkColorActive: '#46c1a8',
      loaderColor: '#FFF',
      error: '#A60306',
      errorColorText: '#CC0407',
      errorPlaceholderColorText: '#B0B5B4',
    },
  };
}

function coinsManiaBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#0f0c18',
      cardSecondaryColor: '#b7b6ba',
      cardBg: '#1b1824',
      inputColor: '#FFF',
      inputLabel: '#cfcfd1',
      inputLabelFocused: '#cfcfd1',
      inputLabelAsteriks: '#cfcfd1',
      inputPlaceholderColor: '#d4d4d5',
      inputBorder: '#322f39',
      inputBorderFocused: '#595465',
      inputBorderError: '#FF0101',
      inputBackground: '#27242f',
      inputBackgroundError: '#27242f',
      inputBackgroundHover: '#27242f',
      inputBackgroundFocus: '#27242f',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#1E1900',
      submitBg: '#f7d400', // rollback color, should overwrite by css
      submitHoverBg: '#f7d400',
      submitActiveBg: '#f7d400',
      submitDisabledBg: '#AC9001',
      submitDisabledColor: '#473B01',
      submitBorder: '#FDDE3F',
      submitBorderDisabled: '#AC9001',
      // submitBoxShadow: '#',
      publicOffer: '#b7b6ba',
      linkColor: '#FFF',
      linkColorHover: '#CCC',
      linkColorActive: '#e6e6e6',
      loaderColor: '#f4c000',
      error: '#FF0101',
      errorColorText: '#ff0000',
      errorPlaceholderColorText: '#d4d4d5',
    },
  };
}

function dexyplayBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F3F4F6',
      background: '#0C0713',
      cardSecondaryColor: '#b8b4b9',
      cardBg: '#2b1c3d',
      inputColor: '#FFF',
      inputLabel: '#bebbbf',
      inputLabelFocused: '#bebbbf',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#bebbbf',
      inputBorder: '#4d4752', // when input have state #
      inputBorderFocused: '#716878',
      inputBorderError: '#FF0019',
      inputBackground: '#261d2b',
      inputBackgroundError: '#261d2b',
      inputBackgroundHover: '#261d2b',
      inputBackgroundFocus: '#261d2b',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#0C0713',
      submitBg: '#afa7fb', // rollback color, should overwrite by css
      submitHoverBg: '#afa7fb', // rollback color, should overwrite by css
      submitActiveBg: '#afa7fb', // rollback color, should overwrite by css
      submitDisabledBg: '#574f5a',
      submitDisabledColor: '#cccacd',
      submitBorder: '#FFF',
      submitBorderDisabled: '#78727b',
      // submitBoxShadow: '#',
      publicOffer: '#b8b4b9',
      linkColor: '#00BFFF',
      linkColorHover: '#33ccff',
      linkColorActive: '#66d9ff',
      loaderColor: '#ffe3a8',
      error: '#FF0019',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#bebbbf',
    },
  };
}

function sweepicoBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#170e2a',
      cardSecondaryColor: '#BCBCD5',
      cardBg: '#2a223b',
      inputColor: '#E2E2F3',
      inputLabel: '#FFF',
      inputLabelFocused: '#FFF',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#9F9FCF',
      inputBorder: '#434388', // when input have state #9F9FCF
      inputBorderFocused: '#7676bb',
      inputBorderError: '#FF3364',
      inputBackground: '#170e2a',
      inputBackgroundError: '#170e2a',
      inputBackgroundHover: '#170e2a',
      inputBackgroundFocus: '#170e2a',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#000',
      submitBg: '#D8FC3E',
      submitHoverBg: '#BFE325',
      submitActiveBg: '#A5C90B',
      submitDisabledBg: '#D8FC3E',
      submitDisabledColor: '#000',
      // submitBorder: '#D8FC3E',
      // submitBorderDisabled: '#0086B2',
      // submitBoxShadow: '#',
      publicOffer: '#CCF2FF',
      linkColor: '#d1ceceff',
      linkColorHover: '#FFF',
      linkColorActive: '#eededeff',
      loaderColor: '#1F02EA',
      error: '#FF3364',
      errorColorText: '#E2E2F3',
      errorPlaceholderColorText: '#E2E2F3',
    },
  };
}

function fireSevensBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F2F8F6',
      background: '#081510',
      cardSecondaryColor: '#78BAA0',
      cardBg: '#1c2823',
      inputColor: '#F2F8F6',
      inputLabel: '#78BAA0',
      inputLabelFocused: '#78BAA0',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#93C7B3',
      inputBorder: '#525b58', // when input have state #9ca29f
      inputBorderFocused: '#83908c',
      inputBorderError: '#F33C20',
      inputBackground: '#081510',
      inputBackgroundError: '#081510',
      inputBackgroundHover: '#081510',
      inputBackgroundFocus: '#081510',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#F2F8F6',
      submitBg: '#F31B34',
      submitHoverBg: '#a0081a',
      submitActiveBg: '#d00b22',
      submitDisabledBg: '#2f3d38',
      submitDisabledColor: '#afb4b3',
      submitBorder: '#CB0B21',
      submitBorderDisabled: '#afb4b3',
      // submitBoxShadow: '#',
      publicOffer: '#CCF2FF',
      linkColor: '#d1ceceff',
      linkColorHover: '#FFF',
      linkColorActive: '#eededeff',
      loaderColor: '#FFF',
      error: '#F33C20',
      errorColorText: '#F2F8F6',
      errorPlaceholderColorText: '#F2F8F6',
    },
  };
}

function vegasWayBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#001319',
      cardSecondaryColor: '#98a1a3',
      cardBg: '#002534',
      inputColor: '#F5FCFF',
      inputLabel: '#33CCFF',
      inputLabelFocused: '#ee6b1e',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#66D9FF',
      inputBorder: '#11262b',
      inputBorderFocused: '#214953ff',
      inputBorderError: '#7D1100',
      inputBackground: '#11262b',
      inputBackgroundError: '#300100',
      inputBackgroundHover: '#300100',
      inputBackgroundFocus: '#300100',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#FF303E',
      submitHoverBg: '#df313c',
      submitActiveBg: '#f74954',
      submitDisabledBg: '#00394D',
      submitDisabledColor: '#0086B2',
      submitBorder: '#FA3845',
      submitBorderDisabled: '#0086B2',
      // submitBoxShadow: '#',
      publicOffer: '#CCF2FF',
      linkColor: '#d1ceceff',
      linkColorHover: '#FFF',
      linkColorActive: '#eededeff',
      loaderColor: '#D60513',
      error: '#BB2B15',
      errorColorText: '#F5FCFF',
      // errorPlaceholderColorText: '#',
    },
  };
}

function playtanaBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#030909',
      cardSecondaryColor: '#B8CAE0',
      cardBg: '#03231b',
      inputColor: '#E0F6F0',
      inputLabel: '#67CAB4',
      inputLabelFocused: '#67CAB4',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#329880',
      inputBorder: '#329880',
      inputBorderFocused: '#66c7b0',
      inputBorderError: '#BB1522',
      inputBackground: '#030909',
      inputBackgroundError: '#030909',
      inputBackgroundHover: '#030909',
      inputBackgroundFocus: '#030909',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#FE3D10',
      submitHoverBg: '#FE3D10',
      submitActiveBg: '#FE3D10',
      submitDisabledBg: '#FE3D10',
      submitDisabledColor: '#FFF',
      submitBorder: '#FE5733',
      submitBorderDisabled: '#FE3D10',
      submitBoxShadow: '#fe3d1066',
      publicOffer: '#FFF',
      linkColor: '#446C9C',
      linkColorHover: '#2b568aff',
      linkColorActive: '#a6b8cfff',
      loaderColor: '#44d3b4',
      error: '#BB1522',
      errorColorText: '#BB1522',
      // errorPlaceholderColorText: '#',
    },
  };
}

function mrGoodwinBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#090e15',
      cardSecondaryColor: '#8DAACD',
      cardBg: '#1d2128',
      inputColor: '#D4DFEC',
      inputLabel: '#FFF',
      inputLabelFocused: '#FFF',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#8DAACD',
      inputBorder: '#192739', // when input have state #8DAACD
      inputBorderFocused: '#c3cad3',
      inputBorderError: '#FF3364',
      inputBackground: '#090e15',
      inputBackgroundError: '#090e15',
      inputBackgroundHover: '#090e15',
      inputBackgroundFocus: '#090e15',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#000',
      submitBg: '#D3FF44', // box-shadow: 0px 0px 20px 0px #068E3ACC;
      submitHoverBg: '#D3FF44',
      submitActiveBg: '#D3FF44',
      submitDisabledBg: '#D3FF44',
      submitDisabledColor: '#000',
      submitBorder: '#192739',
      submitBorderDisabled: '#192739',
      submitBoxShadow: '#068e3acc',
      publicOffer: '#FFF',
      linkColor: '#446C9C',
      linkColorHover: '#2b568aff',
      linkColorActive: '#a6b8cfff',
      loaderColor: '#C233FF',
      error: '#E50037',
      errorColorText: '#D4DFEC',
      errorPlaceholderColorText: '#8DAACD',
    },
  };
}

function stormRushBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F3F6F5',
      background: '#0c130f',
      cardSecondaryColor: '#A5C0B1',
      cardBg: '#1f2622',
      inputColor: '#DCE5E0',
      inputLabel: '#A5C0B1',
      inputLabelFocused: '#DCE5E0',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#A5C0B1',
      inputBorder: '#434945',
      inputBorderFocused: '#5e6660',
      inputBorderError: '#A90017',
      inputBackground: '#1f2622',
      inputBackgroundError: '#1f2622',
      inputBackgroundHover: '#1f2622',
      inputBackgroundFocus: '#1f2622',
      inputBinWarningIconColor: '#ffa500',
      inputBinWarningTextColor: '#ffa500',
      submitColor: '#020D07',
      submitBg: '#A5C0B1',
      // submitHoverBg: '#',
      // submitActiveBg: '#',
      submitDisabledBg: '#333936',
      // submitDisabledColor: '#b6b8b6',
      submitBorder: '#acffb1',
      submitBorderDisabled: '#333936',
      // submitBoxShadow: "#",
      publicOffer: '#F3F6F5',
      linkColor: '#DCE5E0',
      linkColorHover: '#e3eae6',
      linkColorActive: '#b3c6bb',
      loaderColor: '#F5F100',
      error: '#BB152B',
      // errorColorText: '#',
      // errorPlaceholderColorText: '#',
    },
  };
}

function sweepSharkBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#011020',
      cardSecondaryColor: '#D6E9E9',
      cardBg: '#152332',
      inputColor: '#F8FFFF',
      inputLabel: '#90A1AA',
      // inputLabelFocused: '',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#B2C5CF',
      inputBorder: '#003854',
      inputBorderFocused: '#004669',
      inputBorderError: '#FF3364',
      inputBackground: '#011020',
      inputBackgroundError: '#011020',
      inputBackgroundHover: '#011020',
      inputBackgroundFocus: '#011020',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#000',
      submitBg: '#E5FF00',
      submitHoverBg: '#cee600',
      submitActiveBg: '#eaff33',
      submitDisabledBg: '#E5FF00',
      submitDisabledColor: '#CCC',
      // submitBorder: '#FF619E',
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#",
      publicOffer: '#FFF',
      linkColor: '#C7D8E2',
      linkColorHover: '#8fb1c5',
      linkColorActive: '#b9cedb',
      loaderColor: '#00FFE5',
      error: '#FF3364',
      errorColorText: '#F8FFFF',
      errorPlaceholderColorText: '#B2C5CF',
    },
  };
}

function nlcV3Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F3F4F6',
      background: '#2f3144',
      cardSecondaryColor: '#B8BACC',
      cardBg: '#3b3d4d',
      inputColor: '#DCDCE5',
      inputLabel: '#90A1AA',
      // inputLabelFocused: '',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#A5A8C0',
      inputBorder: '#FFF', // 40%  backdrop-filter: blur(24px)
      inputBorderFocused: '#9c9da5',
      inputBorderError: '#A90018',
      inputBackground: '#353744',
      inputBackgroundError: '#353744',
      inputBackgroundHover: '#353744',
      inputBackgroundFocus: '#353744',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#F3F4F6',
      submitBg: '#f3377f',
      // submitHoverBg: '#',
      // submitActiveBg: '#',
      // submitDisabledBg: '#',
      // submitDisabledColor: '#',
      submitBorder: '#FF619E',
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#",
      publicOffer: '#F3F4F6',
      linkColor: '#8F92AE',
      linkColorHover: '#a5a8be',
      linkColorActive: '#bcbece',
      loaderColor: '#25C7F8',
      error: '#BB1522',
      errorColorText: '#DCDCE5',
      errorPlaceholderColorText: '#A5A8C0',
    },
  };
}

function nlcV4Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F3F4F6',
      background: '#2f3144',
      cardSecondaryColor: '#B8BACC',
      cardBg: '#3b3d4d',
      inputColor: '#DCDCE5',
      inputLabel: '#90A1AA',
      // inputLabelFocused: '',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#A5A8C0',
      inputBorder: '#FFF', // 40%  backdrop-filter: blur(24px)
      inputBorderFocused: '#9c9da5',
      inputBorderError: '#A90018',
      inputBackground: '#353744',
      inputBackgroundError: '#353744',
      inputBackgroundHover: '#353744',
      inputBackgroundFocus: '#353744',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#F3F4F6',
      submitBg: '#f3377f',
      // submitHoverBg: '#',
      // submitActiveBg: '#',
      // submitDisabledBg: '#',
      // submitDisabledColor: '#',
      submitBorder: '#FF619E',
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#",
      publicOffer: '#F3F4F6',
      linkColor: '#8F92AE',
      linkColorHover: '#a5a8be',
      linkColorActive: '#bcbece',
      loaderColor: '#25C7F8',
      error: '#BB1522',
      errorColorText: '#DCDCE5',
      errorPlaceholderColorText: '#A5A8C0',
    },
  };
}

function taoFortuneTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#161616',
      cardSecondaryColor: '#DDDDF9',
      cardBg: '#292929',
      inputColor: '#FFF',
      inputLabel: '#FFF',
      // inputLabelFocused: '',
      // inputLabelAsteriks: '',
      inputPlaceholderColor: '#868686',
      inputBorder: '#292929',
      inputBorderFocused: '#767676',
      inputBorderError: '#FF0101',
      inputBackground: '#161616',
      // inputBackgroundError: '',
      // inputBackgroundHover: '',
      // inputBackgroundFocus: '',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#111111',
      submitBg: '#E3EF18',
      submitHoverBg: '#c6d10e',
      submitActiveBg: '#e7f13b',
      submitDisabledBg: '#373737',
      submitDisabledColor: '#BCBCBC',
      // submitBorder: "#",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#",
      publicOffer: '#DDDDF9',
      linkColor: '#A6A6C0',
      linkColorHover: '#b8b8cd',
      linkColorActive: '#acacc4',
      loaderColor: '#F0B01A',
      error: '#D90101',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#868686',
    },
  };
}

function taoFortuneVer2Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#08080C',
      cardSecondaryColor: '#DDDDF9',
      cardBg: '#212024',
      inputColor: '#FFF',
      inputLabel: '#b5b5b6',
      inputLabelFocused: '#b5b5b6',
      // inputLabelAsteriks: '',
      inputPlaceholderColor: '#b5b5b6',
      inputBorder: '#262331',
      inputBorderFocused: '#262331',
      inputBorderError: '#FF0101',
      inputBackground: '#1b1626',
      inputBackgroundError: '#1b1626',
      inputBackgroundHover: '#1b1626',
      inputBackgroundFocus: '#1b1626',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#08080C',
      submitBg: '#C3FF00',
      submitHoverBg: '#9ccc00',
      submitActiveBg: '#b9f200',
      submitDisabledBg: '#C3FF00',
      submitDisabledColor: '#08080C',
      submitBorder: '#E7FF99',
      submitBorderDisabled: '#E7FF99',
      // submitBoxShadow: "#",
      publicOffer: '#FFF',
      linkColor: '#DDDDF9',
      linkColorHover: '#a9a9f0',
      linkColorActive: '#d1d1f7',
      loaderColor: '#fee0a0',
      error: '#FF0101',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#b5b5b6',
    },
  };
}

function scarlettBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#05050F',
      cardSecondaryColor: '#A6A6C0',
      cardBg: '#595971',
      inputColor: '#F8F8FF',
      inputLabel: '#8B8BA5',
      // inputLabelFocused: '',
      inputLabelAsteriks: '#8B8BA5',
      inputPlaceholderColor: '#A6A6C0',
      inputBorder: '#595971',
      inputBorderFocused: '#757592',
      inputBorderError: '#7D0000',
      inputBackground: '#202036',
      inputBackgroundError: '#000',
      inputBackgroundHover: '#595971',
      inputBackgroundFocus: '#595971',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#DB0037',
      submitHoverBg: '#f8003e',
      submitActiveBg: '#ff1953',
      submitDisabledBg: '#DB0037',
      submitDisabledColor: '#72728B',
      // submitBorder: "#",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#000",
      publicOffer: '#72728B',
      linkColor: '#A6A6C0',
      linkColorHover: '#b8b8cd',
      linkColorActive: '#acacc4',
      loaderColor: '#FFE229',
      error: '#BB1515',
      errorColorText: '#F8F8FF',
      errorPlaceholderColorText: '#A6A6C0',
    },
  };
}

function scarlettBlackVer2Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F8F8FF',
      background: '#05050F',
      cardSecondaryColor: '#A6A6C0',
      cardBg: '#17172b',
      inputColor: '#F8F8FF',
      inputLabel: '#8B8BA5',
      // inputLabelFocused: '',
      // inputLabelAsteriks: '#8B8BA5',
      inputPlaceholderColor: '#A6A6C0',
      inputBorder: '#404048',
      inputBorderFocused: '#757592',
      inputBorderError: '#7D0000',
      inputBackground: '#191922',
      inputBackgroundError: '#191922',
      inputBackgroundHover: '#191922',
      inputBackgroundFocus: '#191922',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#F8F8FF',
      submitBg: '#cd0d3e',
      // submitHoverBg: '#f8003e',
      // submitActiveBg: '#ff1953',
      submitDisabledBg: '#530015',
      submitDisabledColor: '#8B8BA5',
      submitBorder: '#e71d4f',
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#000",
      publicOffer: '#72728B',
      linkColor: '#A6A6C0',
      linkColorHover: '#b8b8cd',
      linkColorActive: '#acacc4',
      loaderColor: '#FF3366',
      error: '#BB1515',
      errorColorText: '#F8F8FF',
      // errorPlaceholderColorText: '#A6A6C0',
    },
  };
}

function slotoKingTheme() {
  return {
    dark: false,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#4E4D5E',
      background: '#fff',
      cardSecondaryColor: '#4E4D5E',
      cardBg: '#FFF',
      inputColor: '#4E4D5E',
      inputLabel: '#4E4D5E',
      // inputLabelFocused: '',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#B3B3B3',
      inputBorder: '#B3B3B3',
      inputBorderFocused: '#6b6b6b',
      inputBorderError: '#B3B3B3',
      inputBackground: '#FFF',
      inputBackgroundError: '#FFF',
      inputBackgroundHover: '#FFF',
      inputBackgroundFocus: '#FFF',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#4E4D5E',
      submitBg: '#FFE600',
      submitHoverBg: '#e5ce00',
      submitActiveBg: '#bfac00',
      submitDisabledBg: '#fff499',
      submitDisabledColor: '#B3ADCC',
      // submitBorder: "#",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#000",
      publicOffer: '#B3B3B3',
      linkColor: '#6969cd',
      linkColorHover: '#5b5ba8',
      linkColorActive: '#8989d7',
      loaderColor: '#FFE600',
      error: '#E05252',
      errorColorText: '#4E4D5E',
      errorPlaceholderColorText: '#B3B3B3',
    },
  };
}

function slotoKingBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#AEB9D1',
      background: '#060a0e',
      cardSecondaryColor: '#AEB9D1',
      cardBg: '#1C2331',
      inputColor: '#E8ECF2',
      inputLabel: '#8D9EBE',
      // inputLabelFocused: '',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#88A2BF',
      inputBorder: '#2E3A51',
      inputBorderFocused: '#3c4b69',
      inputBorderError: '#2E3A51',
      inputBackground: '#1C2331',
      inputBackgroundError: '#1C2331',
      inputBackgroundHover: '#1C2331',
      inputBackgroundFocus: '#1C2331',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#1C2331',
      submitBg: '#FFE433',
      submitHoverBg: '#ffe747',
      submitActiveBg: '#ffde05',
      submitDisabledBg: '#ffe747',
      submitDisabledColor: '#1C2331',
      // submitBorder: "#09080D",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#000",
      publicOffer: '#FFD699',
      linkColor: '#E50037',
      linkColorHover: '#fd4346',
      linkColorActive: '#e40307',
      loaderColor: '#FFE600',
      error: '#E05252',
      errorColorText: '#E8ECF2',
      errorPlaceholderColorText: '#88A2BF',
    },
  };
}

function thrippleSevenWhiteTheme() {
  return {
    dark: false,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#09080D',
      background: '#fff',
      cardSecondaryColor: '#09080D',
      cardBg: '#FFF',
      inputColor: '#4A426B',
      inputLabel: '#4A426B',
      // inputLabelFocused: '',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#796EA6',
      inputBorder: '#D0CCE0',
      inputBorderFocused: '#6d619f',
      inputBorderError: '#D0CCE0',
      inputBackground: '#FFF',
      inputBackgroundError: '#FFF',
      inputBackgroundHover: '#FFF',
      inputBackgroundFocus: '#FFF',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#09080D',
      submitBg: '#FFBD00',
      submitHoverBg: '#D19B00',
      submitActiveBg: '#9E7500',
      submitDisabledBg: '#FFE499',
      submitDisabledColor: '#B3ADCC',
      submitBorder: '#09080D',
      // submitBorderDisabled: "#",
      submitBoxShadow: '#000',
      publicOffer: '#796EA6',
      linkColor: '#6969cd',
      linkColorHover: '#5b5ba8',
      linkColorActive: '#8989d7',
      loaderColor: '#FFBD00',
      error: '#E05252',
      errorColorText: '#4A426B',
      errorPlaceholderColorText: '#796EA6',
    },
  };
}

function trippleSevenBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#030508',
      cardSecondaryColor: '#FFF',
      cardBg: '#0D1826',
      inputColor: '#FFF',
      inputLabel: '#6B8DB3',
      // inputLabelFocused: '',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#88A2BF',
      inputBorder: '#796EA6',
      inputBorderFocused: '#a199c0',
      inputBorderError: '#796EA6',
      inputBackground: '#0D1826',
      inputBackgroundError: '#0D1826',
      inputBackgroundHover: '#0D1826',
      inputBackgroundFocus: '#0D1826',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#09080D',
      submitBg: '#FFBD00',
      submitHoverBg: '#D19B00',
      submitActiveBg: '#9E7500',
      submitDisabledBg: '#FFE499',
      submitDisabledColor: '#B3ADCC',
      submitBorder: '#09080D',
      // submitBorderDisabled: "#",
      // submitBoxShadow: "",
      publicOffer: '#FFDD00',
      linkColor: '#FC1418',
      linkColorHover: '#fd4346',
      linkColorActive: '#e40307',
      loaderColor: '#F1C21C',
      error: '#E05252',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#88A2BF',
    },
  };
}

function trippleSevenBlackVer2Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#04110C',
      cardSecondaryColor: '#86C1AA',
      cardBg: '#18241f',
      inputColor: '#FFF',
      inputLabel: '#64AF92',
      inputLabelFocused: '#b3b8b6',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#86C1AA',
      inputBorder: '#68706d',
      inputBorderFocused: '#5e6562',
      // inputBorderFocused: '#858e8a',
      inputBorderError: '#68706d',
      inputBackground: '#04110C',
      inputBackgroundError: '#04110C',
      inputBackgroundHover: '#04110C',
      inputBackgroundFocus: '#04110C',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#F31B34',
      submitHoverBg: '#e70c25',
      submitActiveBg: '#cd0b21',
      submitDisabledBg: '#18241f',
      submitDisabledColor: '#747b79',
      submitBorder: '#D00B22',
      submitBorderDisabled: '#2a3531',
      // submitBoxShadow: "",
      publicOffer: '#FFDD00',
      linkColor: '#FC1418',
      linkColorHover: '#f20307',
      linkColorActive: '#fd4346',
      loaderColor: '#FFF',
      error: '#F66751',
      // errorColorText: '#',
      // errorPlaceholderColorText: '#',
    },
  };
}

function jackpottRabbitTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#0B080C',
      cardSecondaryColor: '#FFF',
      cardBg: '#35293D',
      inputColor: '#FFF',
      inputLabel: '#FFF',
      inputLabelAsteriks: '#FF0101',
      inputPlaceholderColor: '#C0AFCA',
      inputBorder: '#9072A1',
      inputBorderFocused: '#ac95b8',
      inputBorderError: '#9072A1',
      inputBackground: '#1C141F',
      inputBackgroundError: '#1C141F',
      inputBackgroundHover: '#1C141F',
      inputBackgroundFocus: '#1C141F',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#0B080C',
      submitBg: '#EBFF07',
      submitHoverBg: '#d9ec00',
      submitActiveBg: '#c1d200',
      submitDisabledBg: '#626B00',
      submitDisabledColor: '#35293D',
      // submitBorder: "",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "",
      publicOffer: '#C0AFCA',
      linkColor: '#FFF',
      linkColorHover: '#e6e6e6',
      linkColorActive: '#CCC',
      loaderColor: '#EBFF07',
      error: '#FF0101',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#C0AFCA',
    },
  };
}

function nlcTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#141722',
      cardSecondaryColor: '#FFF',
      cardBg: '#23293B',
      inputColor: '#FFF',
      inputLabel: '#FFF',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#9AA0B1',
      inputBorder: '#9AA0B1',
      inputBorderFocused: '#cccfd8',
      inputBorderError: '#9AA0B1',
      inputBackground: '#141722',
      inputBackgroundError: '#141722',
      inputBackgroundHover: '#141722',
      inputBackgroundFocus: '#141722',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#F31D53',
      submitHoverBg: '#e80c44',
      submitActiveBg: '#b50a35',
      submitDisabledBg: '#fff499',
      submitDisabledColor: '#FFF',
      // submitBorder: "",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "",
      publicOffer: '#9AA0B1',
      linkColor: '#6969cd',
      linkColorHover: '#5b5ba8',
      linkColorActive: '#8989d7',
      loaderColor: '#F1C21C',
      error: '#E05252',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#9AA0B1',
    },
  };
}

function nlcV2Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#0b1020',
      cardSecondaryColor: '#FFF',
      cardBg: '#23293B',
      inputColor: '#FAF8FF',
      inputLabel: '#8B90A5',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#A6AAC0',
      inputBorder: '#A6AAC0',
      inputBorderFocused: '#cccfd8',
      inputBorderError: '#96323e',
      inputBackground: '#202536',
      inputBackgroundError: '#2c0007',
      inputBackgroundHover: '#141722',
      inputBackgroundFocus: '#141722',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#F31D53',
      submitHoverBg: '#e80c44',
      submitActiveBg: '#b50a35',
      submitDisabledBg: '#fff499',
      submitDisabledColor: '#FFF',
      // submitBorder: "",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "",
      publicOffer: '#9AA0B1',
      linkColor: '#6969cd',
      linkColorHover: '#5b5ba8',
      linkColorActive: '#8989d7',
      loaderColor: '#1694F8',
      error: '#BB1522',
      errorColorText: '#FAF8FF',
      errorPlaceholderColorText: '#A6AAC0',
    },
  };
}

function fortuneWheelzTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#F8FAFC',
      background: '#0E201D',
      cardSecondaryColor: '#F8FAFC',
      cardBg: '#538969',
      inputColor: '#02170F',
      inputLabel: '#F8FAFC',
      inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#64868B',
      inputBorder: '#CBE1DD',
      inputBorderFocused: '#538969',
      inputBorderError: '#CBE1DD',
      inputBackground: '#F8FAFC',
      inputBackgroundError: '#F8FAFC',
      inputBackgroundHover: '#F8FAFC',
      inputBackgroundFocus: '#F8FAFC',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#02170F',
      submitBg: '#F9D01A',
      submitHoverBg: '#e3bb05',
      submitActiveBg: '#c8a405',
      submitDisabledBg: '#B39305',
      submitDisabledColor: '#594902',
      // submitBorder: "#09080D",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#000",
      publicOffer: '#64868B',
      linkColor: '#6969cd',
      linkColorHover: '#5b5ba8',
      linkColorActive: '#8989d7',
      loaderColor: '#F9D01A',
      error: '#E05252',
      errorColorText: '#02170F',
      errorPlaceholderColorText: '#',
    },
  };
}

function fortuneWheelzVer2Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#001212',
      cardSecondaryColor: '#AABDBD',
      cardBg: '#003333',
      inputColor: '#D0DADA',
      inputLabel: '#608282',
      // inputLabelAsteriks: '#E05252',
      inputPlaceholderColor: '#859F9F',
      inputBorder: '#144343',
      inputBorderFocused: '#1e6464',
      inputBorderError: '#7D0F00',
      inputBackground: '#003333',
      // inputBackgroundError: '#',
      inputBackgroundHover: '#003333',
      inputBackgroundFocus: '#003333',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#391800',
      submitBg: '#FFB902',
      submitHoverBg: '#ffe403',
      submitActiveBg: '#ffb902',
      submitDisabledBg: '#FFB902',
      submitDisabledColor: '#FFB902',
      submitBorder: '#ffffff29',
      submitBorderDisabled: '#ffffff29',
      // submitBoxShadow: "#000",
      publicOffer: '#AABDBD',
      linkColor: '#859F9F',
      linkColorHover: '#91a9a9',
      linkColorActive: '#aabcbc',
      loaderColor: '#FFEA30',
      error: '#BB2815',
      errorColorText: '#BB2815',
      errorPlaceholderColorText: '#859F9F',
    },
  };
}

function vegasBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#001B24',
      cardSecondaryColor: '#FFF',
      cardBg: '#142d35',
      inputColor: '#FFF',
      inputLabel: '#66D9FF',
      // inputLabelAsteriks: "#E05252",
      inputPlaceholderColor: '#00BFFF',
      // inputBorder: "",
      // inputBorderFocused: "",
      // inputBorderError: "#",
      inputBackground: '#142d35',
      inputBackgroundError: '#270702',
      inputBackgroundHover: '#142d35',
      inputBackgroundFocus: '#32484f',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#FF2B39',
      submitHoverBg: '#FF2B39',
      submitActiveBg: '#CC000D',
      submitDisabledBg: '#004D66',
      submitDisabledColor: '#0086B2',
      submitBorder: '#FF2B39',
      submitBorderDisabled: '#004D66',
      // submitBoxShadow: "#000",
      publicOffer: '#0086B2',
      linkColor: '#FF3340',
      linkColorHover: '#fd4346',
      linkColorActive: '#e40307',
      loaderColor: '#FFE600',
      error: '#F66751',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#F66751',
    },
  };
}

function vegasBlackVer2Theme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#545760',
      cardSecondaryColor: '#9e9fa5',
      cardBg: '#121522',
      inputColor: '#FFF',
      inputLabel: '#66D9FF',
      // inputLabelAsteriks: "#",
      inputPlaceholderColor: '#00BFFF',
      // inputBorder: "",
      // inputBorderFocused: "",
      // inputBorderError: "#",
      inputBackground: '#1a1c29',
      inputBackgroundError: '#290301',
      // inputBackgroundHover: '#',
      // inputBackgroundFocus: '#',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#FF2B39',
      submitHoverBg: '#ff4d59',
      submitActiveBg: '#ff404d',
      submitDisabledBg: '#FF2B39',
      submitDisabledColor: '#FFF',
      submitBorder: '#FF3340',
      submitBorderDisabled: '#FF3340',
      // submitBoxShadow: "#",
      publicOffer: '#686a72',
      linkColor: '#858790',
      linkColorHover: '#a3a5ab',
      linkColorActive: '#94969d',
      loaderColor: '#FFF',
      error: '#CF250B',
      errorColorText: '#FFF',
      errorPlaceholderColorText: '#F66751',
    },
  };
}

function wildWinzBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#111218',
      cardSecondaryColor: '#111218',
      cardBg: '#44485F',
      inputColor: '#F3F4F7',
      inputLabel: '#8E92AE',
      inputLabelAsteriks: '#FF2200',
      inputPlaceholderColor: '#8E92AE',
      inputBorder: '#2F3242',
      inputBorderFocused: '#A23ADF',
      inputBorderError: '#2F3242',
      inputBackground: '#1E1F2A',
      inputBackgroundError: '#1E1F2A',
      inputBackgroundHover: '#1E1F2A',
      inputBackgroundFocus: '#1E1F2A',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#111218',
      submitBg: '#33FF44',
      submitHoverBg: '#33FF44',
      submitActiveBg: '#33FF44',
      submitDisabledBg: '#44485F',
      submitDisabledColor: '#8E92AE',
      // submitBorder: "#",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#",
      publicOffer: '#FFF',
      linkColor: '#F3F4F7',
      linkColorHover: '#d6d9e3',
      linkColorActive: '#e6e8ee',
      loaderColor: '#F3F4F7',
      error: '#FF2200',
      errorColorText: '#FF2200',
      errorPlaceholderColorText: '#8E92AE',
    },
  };
}

function fcityTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#000A3F',
      cardSecondaryColor: '#B4B6F0',
      cardBg: '#0D1F80',
      inputColor: '#000A3F',
      inputLabel: '#FFF',
      inputLabelAsteriks: '#D90135',
      inputPlaceholderColor: '#1838E5',
      inputBorder: '#8185EB',
      inputBorderFocused: '#6267e6',
      inputBorderError: '#D90135',
      inputBackground: '#FFF',
      inputBackgroundError: '#FFF',
      inputBackgroundHover: '#FFF',
      inputBackgroundFocus: '#FFF',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#000A3F',
      submitBg: '#00FF93',
      submitHoverBg: '#00BF6E',
      submitActiveBg: '#00ac63',
      submitDisabledBg: '#009958',
      submitDisabledColor: '#000A3F',
      submitBorder: '#8185EB',
      submitBorderDisabled: '#8185EB',
      // submitBoxShadow: "#",
      publicOffer: '#FFF',
      linkColor: '#FF11F9',
      linkColorHover: '#FF2BB0',
      linkColorActive: '#A5086B',
      loaderColor: '#00FF93',
      error: '#D90135',
      errorColorText: '#000A3F',
      errorPlaceholderColorText: '#1838E5',
    },
  };
}

function funrizeBlackTheme() {
  return {
    dark: true,
    colors: {
      // primary: "#",
      // secondary: "#",
      color: '#FFF',
      background: '#0D0D2E',
      cardSecondaryColor: '#A5A5D9',
      cardBg: '#6D6D93',
      inputColor: '#F8F8FF',
      inputLabel: '#8787AC',
      // inputLabelAsteriks: '#',
      inputPlaceholderColor: '#A5A5D9',
      inputBorder: '#3E3E61',
      inputBorderFocused: '#A5A5D9',
      inputBorderError: '#5E0217',
      inputBackground: '#161740',
      inputBackgroundError: '#33032F',
      inputBackgroundHover: '#161740',
      inputBackgroundFocus: '#161740',
      inputBinWarningIconColor: '#e69500',
      inputBinWarningTextColor: '#d98c00',
      submitColor: '#FFF',
      submitBg: '#F805AF',
      submitHoverBg: '#fb35c0',
      submitActiveBg: '#fa10b4',
      submitDisabledBg: '#F805AF',
      submitDisabledColor: '#FFF',
      // submitBorder: "#",
      // submitBorderDisabled: "#",
      // submitBoxShadow: "#",
      publicOffer: '#6D6D93',
      linkColor: '#8B86F4',
      linkColorHover: '#a29ef6',
      linkColorActive: '#918cf5',
      loaderColor: '#8B86F4',
      error: '#CC0031',
      errorColorText: '#CC0031',
      errorPlaceholderColorText: '#A5A5D9',
    },
  };
}
